export default {"src":"/_next/static/media/discord.eaa68a10.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};